<template>

    <v-container fluid grid-list-md>
        <v-layout row wrap>

          <v-flex xs12 class="display-1 font-weight-light">
              NEW MANAGER CURRICULUM
          </v-flex>

          <v-flex xs12 sm4 md2>

            <v-card height="100%">
              <v-img
                height="100%"
                :src="image"
                :lazy-src="image"
              ><template v-slot:placeholder>
                        <v-layout
                          fill-height
                          align-center
                          justify-center
                          ma-0
                        >
                          <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                        </v-layout>
                      </template>
              </v-img>
            </v-card>

          </v-flex>

          <v-flex xs12 sm8 md10>
            <p>The New Manager Curriculum is a set of courses providing foundational skills that help FAA employees transition into their new managerial role. It utilizes a combination of online education, in-classroom learning, and individual development plans to provide materials, practice new skills, and adjust leadership styles to help tackle the challenges and responsibilities of being a manager.</p>
            <p>The curriculum is comprised of four sections that occur over a 12-month period. Mandatory requirements are fulfilled by completing a series of web-based training courses, none of which are more than 30 minutes long, prior to each of the instructor-led training courses.</p>
          </v-flex>


          <v-flex xs12>
              <p></p>
              <v-divider></v-divider>
              <p></p>
            <h1>Overview</h1>
          </v-flex>


          <v-flex xs12 sm10 md8>

            <v-timeline align-top dense clipped>

              <v-timeline-item
                color="cyan"
                fill-dot
              >
                <v-card
                  color="cyan"
                  dark
                >
                  <v-card-title class="title">0 - 3 months</v-card-title>
                  <v-card-text class="white text--primary">

                    <v-layout>
                      <v-flex xs4>
                        <v-img
                          :src="require('@/assets/coursetype-WBT.png')"
                          height="125px"
                          contain
                        ></v-img>
                      </v-flex>
                      <v-flex xs8>
                        <h2>Web-based Training (WBT) Series</h2>
                    
                      </v-flex>
                    </v-layout>

                    <p>Prerequisites to attend the New Manager Course. Each WBT is no more than 30 minutes.</p>


                    <v-data-table light
                      :headers="headers"
                      :items="courses1"
                      class="elevation-1 clickable"
                      hide-default-footer
                      @click:row="openCourseFromTable"
                    >
                      <template v-slot:items="props">
                        <td>{{ props.item.title }}</td>
                        <td>{{ props.item.id }}</td>
                      </template>
                    </v-data-table>

                  </v-card-text>
                </v-card>
              </v-timeline-item>

              <v-timeline-item
                color="green"
                fill-dot
              >
                <v-card
                  color="green"
                  dark
                  @click="openCourse('FAA01200050')"
                  class="clickable"
                >
                  <v-card-title class="title">3 - 6 months</v-card-title>
                  <v-card-text class="white text--primary">

                    <v-layout>
                      <v-flex xs4>
                        <v-img
                          :src="require('@/assets/coursetype-ILT.png')"
                          height="125px"
                          contain
                        ></v-img>
                      </v-flex>
                      <v-flex xs8>
                        <h2>New Manager Course (NMC) FAA01200050</h2>
                      </v-flex>
                    </v-layout>
                    
                        <p><strong>FORMAT</strong> Instructor-led Training (4.5 days)</p>

                        <p><em>NOTE: Must complete prior to taking Leadership for FAA Managers (LFM) WBT prerequisites.</em></p>
  
                        <h3>Topics</h3>
                        <p><strong>Leading Self</strong></p>
                        <ul>
                          <li>Transitioning into a New Role</li>
                          <li>Fundamental Leadership Roles</li>
                          <li>Self-assessment</li>
                        </ul>
                        <p></p>
                        <p><strong>Leading Others</strong></p>
                        <ul>
                          <li>Leveraging Diversity</li>
                          <li>Labor Relations</li>
                          <li>Conduct and Discipline</li>
                          <li>Promoting Employee Performance</li>
                          <li>Conducting Employee Performance Appraisals</li>
                          <li>Handling Unacceptable Performance</li>
                        </ul>

                  </v-card-text>
                </v-card>
              </v-timeline-item>

              <v-timeline-item
                color="pink"
                fill-dot
              >
                <v-card
                  color="pink"
                  dark
                >
                  <v-card-title class="title">6 - 9 months</v-card-title>
                  <v-card-text class="white text--primary">

                    <v-layout>
                      <v-flex xs4>
                        <v-img
                          :src="require('@/assets/coursetype-WBT.png')"
                          height="125px"
                          contain
                        ></v-img>
                      </v-flex>
                      <v-flex xs8>
                        <h2>Web-based Training (WBT) Series</h2>
                      </v-flex>
                    </v-layout>

                    <p>Prerequisites to attend Leadership for FAA Managers (LFM). Each WBT is no more than 30 minutes.</p>

                    <v-data-table light
                      :headers="headers"
                      :items="courses2"
                      class="elevation-1 clickable"
                      hide-default-footer
                      @click:row="openCourseFromTable"
                    >
                      <template v-slot:items="props">
                        <td>{{ props.item.title }}</td>
                        <td>{{ props.item.id }}</td>
                      </template>
                    </v-data-table>

                  </v-card-text>
                </v-card>
              </v-timeline-item>


              <v-timeline-item
                color="orange"
                fill-dot
              >
                <v-card
                  color="orange"
                  dark
                  @click="openCourse('FAA01200070')"
                  class="clickable"
                >
                  <v-card-title class="title">9 - 12 months</v-card-title>
                  <v-card-text class="white text--primary">

                    <v-layout>
                      <v-flex xs4>
                        <v-img
                          :src="require('@/assets/coursetype-ILT.png')"
                          height="125px"
                          contain
                        ></v-img>
                      </v-flex>
                      <v-flex xs8>
                        <h2>Leadership for FAA Managers (LFM) FAA01200070</h2>
                      </v-flex>
                    </v-layout>

                        <p><strong>FORMAT</strong> Instructor-led Training (4.5 days)</p>
                    
                        <p><strong>PREREQUISITES</strong> All new manager prerequisites (26 WBT’s and the Instructor-led New Manager Course) must be completed prior to taking Leadership for FAA Managers (LFM).</p>
                        <p><em>NOTE: Completes New Manager Curriculum mandatory requirements.</em></p>
                        <h3>Topics</h3>
                        <p><strong>Leading Self</strong></p>
                        <ul>
                          <li>Leadership Foundations</li>
                        </ul>
                        <p></p>
                        <p><strong>Leading Others</strong></p>
                        <ul>
                          <li>Employee Engagement</li>
                          <li>Employee Development</li>
                          <li>Improving Employee Performance and Productivity</li>
                          <li>Mentoring Employees</li>
                          <li>Team Development</li>
                          <li>Conflict Resolution</li>
                        </ul>
                        <p></p>
                        <p><strong>Leading the Organization</strong></p>
                        <ul>

                          <li>Collaboration</li>
                          <li>Financial Management</li>
                          <li>Culminating Activity</li>
                        </ul>

                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>

          </v-flex>

        </v-layout>
    </v-container>
</template>


<script>

export default{
  props: ['id'],
  data () {
        return {
        image: require('@/assets/new_manager_curr.jpg'),
        headers: [
          { text: 'COURSE NAME', align: 'left', sortable: false, value: 'title' },
          { text: 'COURSE #',    align: 'left', sortable: false, value: 'id'}
        ],
        courses1: [
          { title: 'Welcome to FAA Management', id: 'FAA01200056' },
          { title: 'Transitioning into Management', id: 'FAA01200402' },
          { title: 'Managing Leave', id: 'FAA01200420' },
          { title: 'Time and Attendance', id: 'FAA01200421' },
          { title: 'FAA Core Compensation and Pay', id: 'FAA01200423' },
          { title: 'Leading Performance Management', id: 'FAA01200051' },
          { title: 'Setting Performance Standards', id: 'FAA01200053' },
          { title: 'Managing Performance in the FAA', id: 'FAA01200406' },
          { title: 'Conduct and Discipline: Basics of Ethical Behavior', id: 'FAA01200415' },
          { title: 'Conduct and Discipline: Conducting an Investigation', id: 'FAA01200416' },
          { title: 'Labor Relations for FAA Managers', id: 'FAA01200063' },
          { title: 'Conduct and Discipline: Disciplining Process', id: 'FAA01200417' },
          { title: 'Managing Multigenerational Employees', id: 'amg_05_a02_bs_enus' }
        ],
        courses2: [
          { title: 'Equal Employment Opportunity: Preventing Discrimination', id: 'FAA01200408' },
          { title: 'Equal Employment Opportunity: Understanding Reasonable Accommodation', id: 'FAA01200410' },
          { title: 'Mentoring Employees', id: 'FAA01200087' },
          { title: 'Coaching Employees', id: 'FAA01200085' },
          { title: 'FAA Hiring Process and the Role of the Hiring Manager', id: 'FAA30201393' },
          { title: 'Managerial Workforce Planning', id: 'FAA01200404' },
          { title: 'FAA Leadership Fundamentals', id: 'FAA01200068' },
          { title: 'Financial Management Responsibilities', id: 'FAA01200428' },
          { title: 'In Pursuit of Leadership', id: 'FAA01200403' },
          { title: 'Stress and Trauma Management', id: 'FAA01200427' },
          { title: 'WorkLife Solutions', id: 'FAA01200419' },
          { title: 'Maximizing Employee Engagement', id: 'FAA30201257' },
          { title: 'Individual Development Plan', id: 'FAA01200086' }
        ]
    }
  },
  methods: {
    openCourseFromTable(item) {
      this.openCourse(item.id)
    },
    openCourse(id) {
      this.$router.push({ path: '/course/' + id });
    }
  }
}
</script>

<style>
.clickable {
  cursor: pointer;
}
.v-data-table__mobile-row__header {
  display: none;
}
.v-data-table__mobile-row__cell {
  text-align: left;
}

</style>
